<app-header-top #headerTopComponent
                [breadcrumbs]="breadcrumbs"
                [title]="labelRettifica | titlecase"
                [showClickSave]="ordine.data.stato == STATO_ORDINE.BOZZA"
                [pvenditaId]="pVenditaId"
                (clickSave)="saveOrder(true, $event)">
</app-header-top>

<mat-tab-group mat-align-tabs="left" class="invisible-tabs" #tabs
               [selectedIndex]="selectedIndex">
   <mat-tab label="Informazioni Generali">
      <div class="container">
         <app-informazioni-rettifica #infoRettificaComponent
                                     [ordine]="ordine"
                                     [isRettifica]="true"
                                     [tipoRettifica]="tipoRettifica"
                                     (clickNext)="setBreadcrumb($event);">
         </app-informazioni-rettifica>
      </div>
   </mat-tab>

   <mat-tab label="Informazioni Generali">
      <div class="container">
         <app-composizione-rettifica #composizioneRettificaComponent
                                     [isAmmanco]="true"
                                     [tipoRettifica]="tipoRettifica"
                                     [ordine]="ordine"
                                     [pVenditaId]="pVenditaId"
                                     [vendorSlug]="vendorSlug"
                                     [ordiniSlave]="ordiniSlave"
                                     (clickNext)="setBreadcrumb($event);"
                                     (clickSave)="saveOrder(true)"
         >
         </app-composizione-rettifica>
      </div>
   </mat-tab>

   <mat-tab label="Informazioni Generali">
      <div class="container">
         <app-riepilogo-rettifica [tipoRettifica]="tipoRettifica"
                                  [ordine]="ordine"
                                  [ordiniSlave]="ordiniSlave"
                                  [vendorSlug]="vendorSlug"
                                  [pVenditaId]="pVenditaId"
                                  (clickSave)="saveOrder(false, true)"
         ></app-riepilogo-rettifica>
      </div>
   </mat-tab>

</mat-tab-group>
